<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.loginList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.loginList')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="loginList.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.timeStamp')}}</th>
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th>{{$t('form.setting.username')}}</th>
                                            <th>{{$t('form.setting.email')}}</th>
                                            <th>{{$t('form.setting.authenticatedBy')}}</th>
                                            <th>{{$t('form.setting.status')}}</th>
                                            <th>{{$t('form.setting.ipAddress')}}</th>
                                            <!-- <th class="text-right">{{$t('form.setting.action')}}</th> -->
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(item, index) in loginList" :key="index">
                                            <td>{{item.created_at|formatDate(datetimeFormat)}}</td>
                                            <td>{{item.name}}</td>
                                            <td>{{item.username}}</td>
                                            <td>{{item.email}}</td>
                                            <td>{{item.authenticated_by}}</td>
                                            <td>{{item.status}}</td>
                                            <td>{{item.ip_address}}</td>

                                            <!-- <td class="text-right">
                                                <button v-if="permissions.editSettingsPositions"
                                                    class="btn btn-info btn-sm" @click="edit(position, 'staff')">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsPositions"
                                                    class="btn btn-danger btn-sm" @click="remove(position, index)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td> -->
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="pagination.last_page > 1"
                                :pagination="pagination" :offset="5" @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'datetimeFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                pagination: {
                    current_page: 1
                },
                loginList: [],
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsLoginlist) {
                return this.$router.push('/');
            }

            this.getloginList();
        },

        methods: {

            getloginList() {
                this.isLoading = true;

                axios
                    .get('/api/login-list?page=' + this.pagination.current_page)
                    .then(response => {
                        this.loginList = response.data.data.data;
                        this.pagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate() {
                this.getloginList();
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>
